import React, { useState, useEffect } from 'react';
import Map, { Marker, NavigationControl } from 'react-map-gl';
import Supercluster from 'supercluster';
import { Modal, Box, Typography, Button, Stack } from '@mui/material';
import ImageGallery from 'react-image-gallery';
import 'mapbox-gl/dist/mapbox-gl.css';

const MAPBOX_TOKEN = 'pk.eyJ1IjoiYXZhenF1ZXpndWFyZGlhbiIsImEiOiJjbHBwb3FvcDgweWxlMmlxams3MWFveHlmIn0.ju2vyO6CR3zowGtWRnwxsQ'; // Put your Mapbox token here

export default function CustomMap({ places }) {
  const [viewport, setViewport] = useState({
    latitude: 18.4437581,
    longitude: -66.0587558,
    zoom: 12,
  });
  const [clusters, setClusters] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedPlace, setSelectedPlace] = useState(null);

  const navControlStyle = {
    right: 10,
    top: 10
  };

  const handleOpen = (place) => {
    setSelectedPlace(place);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedPlace(null);
  };

  // Convert places to GeoJSON Features
  const points = places.map(place => ({
    type: 'Feature',
    properties: { cluster: false, id: place.title, ...place }, // Spread place properties
    geometry: { type: 'Point', coordinates: place.coordinates }
  }));
 
  // Initialize and configure the cluster
  const cluster = new Supercluster({
    radius: 80,
    maxZoom: 16,
  });

  useEffect(() => {
    cluster.load(points);
    const clusters = cluster.getClusters([-180, -85, 180, 85], viewport.zoom);
    setClusters(clusters);
  }, [points]);

  return (
    <>
      <Map
  mapboxAccessToken={MAPBOX_TOKEN}
  initialViewState={viewport}
  style={{ width: '100%', height: '30vh' }}
  mapStyle="mapbox://styles/mapbox/streets-v9"
  onMove={evt => setViewport(evt.viewState)}
>
  <NavigationControl style={navControlStyle} />
  {clusters.map(cluster => {
    const isCluster = cluster.properties.cluster;
    const placeCategory = cluster.properties.category; // Assuming you have a property for place category

    let backgroundColor = '#ec635e'; // Default color

    if (placeCategory == 'Attractions') {
      backgroundColor = 'rgba(236, 99, 94, 0.7)';
    } else if (placeCategory === 'Unique Stays') {
      backgroundColor = 'rgba(9, 12, 155, 0.7)'; // Change to blue for Unique Stays
    } else if (placeCategory === 'Restaurants & Bars') {
      backgroundColor = 'rgba(0, 128, 0, 0.7)'; // Change to red for Restaurants & Bars
    } 

    return (
      <Marker
        key={cluster.properties.cluster_id || cluster.properties.id}
        longitude={cluster.geometry.coordinates[0]}
        latitude={cluster.geometry.coordinates[1]}
      >
        {isCluster ? (
          <div
            style={{
              width: 60,
              height: 60,
              backgroundColor,
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: 'white',
              fontSize: '12px',
            }}
          >
            {cluster.properties.point_count}
          </div>
        ) : (
          <div
            style={{ backgroundColor, width: '20px', height: '20px', borderRadius: '50%' }}
            onClick={() => handleOpen(cluster.properties)}
          ></div>
        )}
      </Marker>
    );
  })}
</Map>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
       <Box 
            sx={{ 
              position: 'absolute', 
              top: '50%', 
              left: '50%', 
              transform: 'translate(-50%, -50%)',
              width: { xs: '90%', sm: '70%', md: '60%', lg: '50%' }, // Responsive width
              bgcolor: 'background.paper', 
              boxShadow: 24, 
              p: 4, 
              overflowY: 'auto', 
              maxHeight: '90vh' 
            }}
          >
          {selectedPlace && (
            <>
                <ImageGallery 
                items={selectedPlace.images.map(image => ({original: image, thumbnail: image}))} 
                additionalClass="custom-image-gallery" 
                showPlayButton={false} 
                showThumbnails={false} 
                showFullscreenButton={false}
              />
               <Stack spacing={2} sx={{ mt: 2 }}> {/* Use Stack for organized spacing */}
              <Typography id="modal-modal-title" variant="h6" component="h2">
                {selectedPlace.title}
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {selectedPlace.description}
              </Typography>
              {/* Add additional content based on selectedPlace here */}
              {/* Example: Actions */}
              </Stack>
             
              {selectedPlace.actions && selectedPlace.actions.map((action, index) => (
                <Button key={index} variant="contained" sx={{ mt: 2 }}  onClick={() => window.open(action.url)}>
                  {action.name}
                </Button>
              ))}
            </>
          )}
        </Box>
      </Modal>
    </>
  );
}
